import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/300-italic.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500-italic.css";
import "@fontsource/roboto/700-italic.css";
import "@fontsource/raleway/300.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/500.css";
import "@fontsource/raleway/700.css";
import "@fontsource/raleway/300-italic.css";
import "@fontsource/raleway/400-italic.css";
import "@fontsource/raleway/500-italic.css";
import "@fontsource/raleway/700-italic.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/300-italic.css";
import "@fontsource/lato/400-italic.css";
import "@fontsource/lato/700-italic.css";
import "@fontsource/lora/index.css";
import "reflect-metadata";
import "global-styles.css";
import "!file-loader?name=[name].[ext]!./static/images/communitycliq-favicon.png";
import "sanitize.css/sanitize.css";

import { setAutoFreeze, enableMapSet } from "immer";

import { initSentry } from "lib/sentry";
import { configureAxiosInstance } from "utils/axios";

export function initApp() {
  // Allow immer to manage maps and sets. This must be enabled or the immer map codes isn't bundled.
  enableMapSet();
  setAutoFreeze(false);
  configureAxiosInstance();
  initSentry();

  if ("serviceWorker" in navigator) {
    void navigator.serviceWorker.register("/sw.js");
  }
}
